var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.formSection.questions),function(question,index){return _c('div',{key:index + question.questionKey,staticClass:"question-container"},[_c('form-template-question',{attrs:{"question":question}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }